import { useQuery } from "@tanstack/react-query";
import { api } from "./api";

export interface ProjectListItem {
  id: number;
  name: string;
  funnelId: number;
  subdomain: string | null;
  customHostname: string | null;
  active: boolean;
  /** TASK-228 — ISO-Z, null when not archived. */
  archivedAt: string | null;
  createdAt: string;
  last24h: number;
  sparkline: number[];
  days: string[];
  bqStatsAvailable: boolean;
  fairUseRejectionsToday: number;
  workspace: "agentur" | "marketingabteilung";
}

export interface ProjectsFilters {
  q?: string;
  status?: "all" | "active" | "paused" | "archived";
  sort?: "name" | "created" | "events24h";
  workspace?: "all" | "agentur" | "marketingabteilung";
}

export function useProjects(filters: ProjectsFilters = {}) {
  return useQuery<{ items: ProjectListItem[]; total: number }>({
    queryKey: ["admin", "projects", "list", filters],
    queryFn: () => {
      const p = new URLSearchParams();
      if (filters.q) p.set("q", filters.q);
      if (filters.status && filters.status !== "all")
        p.set("status", filters.status);
      if (filters.sort) p.set("sort", filters.sort);
      if (filters.workspace && filters.workspace !== "all")
        p.set("workspace", filters.workspace);
      const qs = p.toString();
      return api(`/admin/projects${qs ? `?${qs}` : ""}`);
    },
    staleTime: 30_000,
  });
}
